
import en from './us-en.js' //导入英文语言包
import cn from './zh-cn.js' //导入英文语言包
export default {
  zhCN: cn,
  enGB: en
}
 